import { looksLikeMarkdown } from '@/pages/authenticated/workflows/components/looksLikeMarkdown';

export type StaticDefaultChipMode =
  'string' | 'number' | 'boolean' | 'indicator';

/**
 * Pick how a static default should render on the canvas.
 * Complex values (json / arrays / markdown) get a compact indicator;
 * simple scalars get an inline editor.
 */
export function getStaticDefaultChipMode(
  socketType: string | undefined,
  value: unknown,
): StaticDefaultChipMode {
  const type = socketType ?? 'any';

  if (type === 'boolean') return 'boolean';
  if (type === 'number') return 'number';

  if (type === 'json' || type.startsWith('array<')) {
    return 'indicator';
  }

  if (
    (type === 'string' || type === 'any') &&
    typeof value === 'string' &&
    looksLikeMarkdown(value)
  ) {
    return 'indicator';
  }

  // string / any / uuid / date / other scalars → inline text
  return 'string';
}

/** Compact glyph for complex static defaults (edit in the side panel). */
export function getStaticDefaultIndicator(
  socketType: string | undefined,
  value: unknown,
): string {
  const type = socketType ?? 'any';

  if (type.startsWith('array<')) return '[]';
  if (type === 'json') return '{}';

  if (
    (type === 'string' || type === 'any') &&
    typeof value === 'string' &&
    looksLikeMarkdown(value)
  ) {
    // eslint-disable-next-line i18next/no-literal-string -- typographic glyph, not UI copy
    return '""';
  }

  if (typeof value === 'object' && value !== null) {
    return Array.isArray(value) ? '[]' : '{}';
  }

  // eslint-disable-next-line i18next/no-literal-string -- typographic glyph, not UI copy
  return '…';
}
